














import { NoteApi } from "../../api/NoteApi";
import NoteDisplay from "./NoteDisplay.vue";

export default {
    name: "NotesList",
    components: { NoteDisplay },
    data() {
        return {
            notes: [],
            NoteApi: new NoteApi(),
        };
    },
    created() {
        this.refreshList();
    },
    methods: {
        refreshList: function () {
            let self = this;
            self.NoteApi.getAll().then((response) => {
                self.notes = response;
            });
            self.$emit("refresh-count");
        },
        closeModal: function () {
            this.$emit("close-modal");
        },
    },
};
